import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  TableCell,
  TableRow,
  IconButton,
  Typography,
  Link,
  Collapse,
  Box,
  Table,
  TableHead,
  TableBody,
} from '@material-ui/core';
import { DeleteOutline, Edit } from '@material-ui/icons';
import { DateTime } from 'luxon';
import AlterarCampanhaModal from './modals/AlterarCampanhaModal';
import ExclusaoCampanhaModal from './modals/ExclusaoCampanhaModal';
import { StatusCampanha } from '../../../../../helpers/enums';
import AdicaoRegrasCampanhas from './modals/AdicaoRegrasCampanhas';
import { formatPrice } from '../../../../../helpers/utils';
import { theme } from '../../../../../theme';

export function CampanhasTableRow(props) {
  const { clientesData, refetch, classes } = props;
  const [alteracaoModal, setAlteracaoModal] = useState(false);
  const [exclusaoModal, setExclusaoModal] = useState(false);
  const [adicaoRegrasCampanhasModal, setAdicaoRegrasCampanhasModal] = useState(false);
  const [regrasCampanhas, setRegrasCampanhas] = useState([]);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [formData, setFormData] = useState({
    nome: clientesData.nome || '',
    redirecionamento: clientesData.redirecionamento || '',
    imgDesktop: clientesData.imgDesktop || '',
    imgMobile: clientesData.imgMobile || '',
    dataInicio: clientesData?.dataInicio ? DateTime.fromFormat(clientesData?.dataInicio, 'dd/MM/yyyy').toISODate() : '',
    dataFim: clientesData?.dataFim ? DateTime.fromFormat(clientesData?.dataFim, 'dd/MM/yyyy').toISODate() : '',
    status: clientesData.status || StatusCampanha.Inativa,
    activationRules: clientesData.activationRules || [],
  });

  const handleOnClose = modal => {
    if (modal === 'alteracao') {
      setAlteracaoModal(false);
    } else {
      setExclusaoModal(false);
    }
    refetch();
  };

  const handleToggleCollapse = event => {
    event.stopPropagation();
    setCollapseOpen(prev => !prev);
  };

  return (
    <>
      <TableRow key={clientesData?.id} onClick={handleToggleCollapse} style={{ cursor: 'pointer' }}>
        <TableCell className={classes.smallerTableCell}>{clientesData?.nome}</TableCell>
        <TableCell className={classes.largerTableCell}>{clientesData?.redirecionamento}</TableCell>
        <TableCell className={classes.largerTableCell}>
          <Typography variant="body2">
            <Link href={clientesData?.presignedDesktop} target="_blank" rel="noopener noreferrer">
              {clientesData?.imgDesktop}
            </Link>
          </Typography>
        </TableCell>
        <TableCell className={classes.largerTableCell}>
          <Typography variant="body2">
            <Link href={clientesData?.presignedMobile} target="_blank" rel="noopener noreferrer">
              {clientesData?.imgMobile}
            </Link>
          </Typography>
        </TableCell>
        <TableCell className={classes.smallerTableCell}>{clientesData?.dataInicio}</TableCell>
        <TableCell className={classes.smallerTableCell}>{clientesData?.dataFim}</TableCell>
        <TableCell className={classes.smallerTableCell}>{StatusCampanha.getStatus(clientesData?.status)}</TableCell>
        <TableCell className={classes.actionsTableCell}>
          <IconButton onClick={() => setAlteracaoModal(true)} className={classes.editButton}>
            <Edit />
          </IconButton>
          <IconButton
            onClick={() => setExclusaoModal(true)}
            className={classes.excludeButton}
            disabled={clientesData?.status === 'ATIVA'}
          >
            <DeleteOutline />
          </IconButton>
        </TableCell>
      </TableRow>

      {collapseOpen && (
        <TableRow>
          <TableCell colSpan={8} style={{ padding: 0 }}>
            <Collapse in={collapseOpen} timeout="auto" unmountOnExit>
              <Box p={2} style={{ backgroundColor: theme.palette.serena.secondary, overflowX: 'auto' }}>
                <Typography variant="subtitle2" gutterBottom>
                  Regras de Ativação:
                </Typography>
                {formData.activationRules && formData.activationRules.length > 0 ? (
                  formData.activationRules.map(activationRule => (
                    <Box key={`activation-rule-${activationRule.distributors}-${activationRule.rules.length}`} mb={3}>
                      <Typography variant="body2" gutterBottom>
                        <strong>Distribuidoras:</strong> {activationRule.distributors.join(', ')}
                      </Typography>

                      <Table size="small">
                        <TableHead>
                          <TableRow className={classes.headRowStyle}>
                            <TableCell>
                              <strong>Valor Mínimo (MWh)</strong>
                            </TableCell>
                            <TableCell>
                              <strong>Valor Máximo (MWh)</strong>
                            </TableCell>
                            <TableCell>
                              <strong>Valor do Desconto (R$)</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {activationRule.rules.map((rule, ruleIdx) => (
                            <TableRow
                              key={`activation-rule-${activationRule.distributors}-${activationRule.rules.length}`}
                              className={`${classes.allRowsStyle} ${ruleIdx === 0 ? classes.firstRowStyle : ''} ${
                                ruleIdx === activationRule.rules.length - 1 ? classes.lastRowStyle : ''
                              }`}
                            >
                              <TableCell>{rule.mwMinValue}</TableCell>
                              <TableCell>{rule.mwMaxValue || 'Sem limite'}</TableCell>
                              <TableCell>{formatPrice(rule.discountAmount)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    Nenhuma regra de ativação cadastrada.
                  </Typography>
                )}
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      )}

      <AlterarCampanhaModal
        clientesData={clientesData}
        refetch={refetch}
        open={alteracaoModal}
        onClose={() => handleOnClose('alteracao')}
        classes={classes}
        adicaoRegrasCampanhasModal={adicaoRegrasCampanhasModal}
        setAdicaoRegrasCampanhasModal={setAdicaoRegrasCampanhasModal}
        setFormData={setFormData}
        formData={formData}
      />
      <AdicaoRegrasCampanhas
        open={adicaoRegrasCampanhasModal}
        onClose={() => setAdicaoRegrasCampanhasModal(false)}
        regrasCampanhas={regrasCampanhas}
        setRegrasCampanhas={setRegrasCampanhas}
        classes={classes}
        setFormData={setFormData}
      />
      <ExclusaoCampanhaModal
        clientesData={clientesData}
        refetch={refetch}
        open={exclusaoModal}
        onClose={() => handleOnClose('exclusao')}
      />
    </>
  );
}

CampanhasTableRow.propTypes = {
  clientesData: PropTypes.shape({
    id: PropTypes.string,
    nome: PropTypes.string,
    redirecionamento: PropTypes.string,
    imgDesktop: PropTypes.string,
    imgMobile: PropTypes.string,
    dataInicio: PropTypes.string,
    dataFim: PropTypes.string,
    status: PropTypes.string,
    activationRules: PropTypes.array,
  }).isRequired,
  refetch: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};
